import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { mainurl } from '../../MainUrl';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/layout/Page';
import Title from '../../component/layout/Title';
import { Row, Col, Card, CardBody, Spinner } from 'reactstrap';
import { notification } from '../../component/hocs/notification';
import DataTable from 'react-data-table-component';

const ViewCustomer = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch all customers (view_customer)
  const get_list_handler = () => {
    setLoading(true);
    axios
      .get(mainurl + 'view_customer')
      .then((response) => {
        console.log('View Customer API Response:', response.data);
        const list = response.data.data.map((row, index) => ({
          sl: index + 1,
          Customer_Code: row?.customer_code ?? '',
          Customer_Name: row?.customer_name ?? '',
          Ph_No: row?.ph_no ?? '', // Added phone number
          Email: row?.email ?? '', // Added email
          ...row,
        }));
        setTableData(list);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error in View Customer API:', error);
        setLoading(false);
        notification('error', 'Failed to fetch customer data');
      });
  };

  useEffect(() => {
    get_list_handler();
  }, []);

  const custTableStyles = {
    rows: { highlightOnHover: true },
    headCells: {
      style: {
        fontWeight: 'bold',
        backgroundColor: '#FF0000',
        color: 'white',
      },
    },
    cells: { style: { padding: '10px' } },
  };

  return (
    <div>
      <Header />
      <Page>
        <Row className="mb-3">
          <Col xs={12} className="mb-1">
            <Title pageTitle="View Customers" />
          </Col>

          <Col xs={12}>
            <Card color="primary" outline>
              <CardBody>
                {loading ? (
                  <div className="text-center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <DataTable
                    customStyles={custTableStyles}
                    columns={[
                      { name: '#', selector: (row) => row.sl, width: '50px' },
                      { name: 'Customer Code', selector: (row) => row.Customer_Code },
                      { name: 'Customer Name', selector: (row) => row.Customer_Name },
                      { name: 'Phone No', selector: (row) => row.Ph_No }, // Added Phone No column
                      { name: 'Email', selector: (row) => row.Email }, // Added Email column
                    ]}
                    data={tableData}
                    keyField="sl"
                    
                    progressPending={loading}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
      <Footer />
    </div>
  );
};

export default ViewCustomer;
